import { useState } from "react";
import axios from "axios";
import CalendarioFiltrado from "./CalendarioFiltrado";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
const GuardiaForm = () => {
  const [dnis, setDnis] = useState("");
  const [fechaGuardia, setFechaGuardia] = useState("");
  const [tipo, setTipo] = useState("Ordinaria");
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState("");
  const Usuario = ObtieneDatosCookies()
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Verifica que no haya campos vacíos
    if (!dnis.trim() || !fechaGuardia || !tipo) {
      setError("Todos los campos son requeridos.");
      return;
    }

    // Elimina cualquier carácter no numérico de los DNIs
    const dnisArray = dnis.split("\n")
      .map(dni => dni.trim())
      .filter(dni => dni && /^[0-9]+$/.test(dni)); // Solo permite números

    // Verifica si se han ingresado DNIs válidos
    if (dnisArray.length === 0) {
      setError("Los DNIs deben contener solo números.");
      return;
    }

    // Elimina DNIs duplicados
    const uniqueDnis = [...new Set(dnisArray)];

    const data = {
      dnis: uniqueDnis,
      fechaGuardia,
      tipo,
      usuarioCreo :Usuario.identificacion,
      destinoUsuario:Usuario.dependenciaNombre,
      estado: "Activa",
    };

    try {
    
      const response = await axios.post(process.env.REACT_APP_BASEURL + "/NCadetes/generarGuardias", data);
      setResponseData(response.data); // Guardamos la respuesta en el estado
      setError(""); // Limpiar errores si todo va bien
    } catch (error) {
      console.error("Error al enviar los datos:", error);
      setError("Error al enviar los datos.");
    }
  };
  const manejarFechaSeleccionada = (fecha) => {
//     console.log(fecha.toISOString().split('T')[0]);
  };
  const styles = {
    form: {
      padding: "16px",
      border: "1px solid #ddd",
      borderRadius: "8px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      width: "320px",
      margin: "0 auto",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      backgroundColor: "#fff"
    },
    textarea: {
      border: "1px solid #ccc",
      padding: "8px",
      width: "100%",
      height: "100px",
      borderRadius: "4px",
    },
    input: {
      border: "1px solid #ccc",
      padding: "8px",
      width: "100%",
      borderRadius: "4px",
    },
    select: {
      border: "1px solid #ccc",
      padding: "8px",
      width: "100%",
      borderRadius: "4px",
    },
    button: {
      backgroundColor: "#007bff",
      color: "#fff",
      padding: "10px",
      borderRadius: "4px",
      border: "none",
      cursor: "pointer",
      fontSize: "16px"
    },
    error: {
      color: "red",
      fontSize: "14px",
      marginTop: "10px",
    },
    success: {
      color: "green",
      fontSize: "14px",
      marginTop: "10px",
    },
    responseContainer: {
      marginTop: "20px",
      padding: "10px",
      backgroundColor: "#f9f9f9",
      border: "1px solid #ddd",
      borderRadius: "4px",
    },
    list: {
      listStyleType: "none",
      padding: "0",
    },
    listItem: {
      padding: "5px 0",
    },
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <textarea
        placeholder="Ingrese DNIs (uno por línea)"
        value={dnis}
        onChange={(e) => setDnis(e.target.value)}
        style={styles.textarea}
      />
      <input
        type="date"
        value={fechaGuardia}
        onChange={(e) => setFechaGuardia(e.target.value)}
        style={styles.input}
      />
      <select
        value={tipo}
        onChange={(e) => setTipo(e.target.value)}
        style={styles.select}
      >
        <option value="Ordinaria">Ordinaria</option>
        <option value="Refuerzo">Refuerzo</option>
        <option value="Recargo">Recargo</option>
        <option value="Recupera">Recupera</option>
     
      </select>
      {error && <div style={styles.error}>{error}</div>}
      <button type="submit" style={styles.button}>Enviar</button>

      {responseData && (
        <div style={styles.responseContainer}>
          <h4>{responseData.message}</h4>
          
          {responseData.creados.length > 0 && (
            <>
              <h5>Guardias Creadas:</h5>
              <ul style={styles.list}>
                {responseData.creados.map((item, index) => (
                  <li key={index} style={styles.listItem}>
                    {/* Muestra las propiedades del objeto que necesitas renderizar */}
                    {`ID: ${item.id}, DNI: ${item.cadeteDni}, Fecha: ${item.fechaGuardia}, Tipo: ${item.tipo}`}
                  </li>
                ))}
              </ul>
            </>
          )}

          {responseData.noCreados.length > 0 && (
            <>
              <h5>No se pudieron crear las siguientes guardias:</h5>
              <ul style={styles.list}>
                {responseData.noCreados.map((item, index) => (
                  <li key={index} style={styles.listItem}>
                    {/* Muestra las propiedades del objeto que necesitas renderizar */}
                    {`DNI: ${item.dni}, Motivo: ${item.motivo}`}
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
      {Usuario.destino==7?<> <div>
      <CalendarioFiltrado 
       
        onSeleccionarFecha={manejarFechaSeleccionada}
      />
    </div></>:""}
     
    </form>
  
  );
};

export default GuardiaForm;
